import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';

import { ShCacheInterceptor } from '@stylehaven/components';
import { TokenInterceptor } from '../token.interceptor';
import { RefreshTokenInterceptor } from './refresh-token.interceptor';
import { Observable, Subject } from 'rxjs';

// The order of these interceptors is very important, do not change or application will not handle refresh token as it should.

export const tokenInterceptorProviders = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: RefreshTokenInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ShCacheInterceptor,
        multi: true
    }
];

export interface TokenRefreshStrategy {
    refreshToken(
        req: HttpRequest<any>,
        next: HttpHandler,
        callBackSubject: Subject<string | undefined>
    ): Observable<HttpEvent<any>>;
}
